@if (decks && decks.length > 0) {
    <div class="flex flex-col" [ngClass]="{ 'hidden' : !isVisible }">
        <div class="flex flex-row gap-2 mt-2 mb-2">
            <div class="font-bold pl-2 w-full">
                @if (userDeckComponentRef.isOwnDecks) {
                    <input #nameDisplayInput (change)="onNameChange(nameDisplayInput)" type="text" [attr.value]="name" class="bg-transparent w-full pl-1 pr-1">
                } @else {
                    <div class="bg-transparent w-full pl-1 pr-1">
                        {{ name }}
                    </div>
                }
            </div>
        </div>
        @for (deck of decks ; track deck.id) {
            <deck-preview [username]="userDeckComponentRef.username" [isOwnDecks]="userDeckComponentRef.isOwnDecks" [deck]="deck" [groupComponentRef]="this"></deck-preview>
        }
    </div>
}